import { Link } from 'react-router-dom';

import { RESIDENTS } from '@/data/events';

import styles from './ResidentsPreview.module.css';

interface ResidentsPreviewProps {
  count?: number;
}

export default function ResidentsPreview({ count = 8 }: ResidentsPreviewProps) {
  return (
    <div className={styles.grid}>
      {RESIDENTS.slice(0, count).map((a, i) => (
        <Link to="/artists" key={a.slug} className={styles.cell}>
          <span className={styles.num}>/{String(i + 1).padStart(3, '0')}</span>
          <span className={styles.role}>
            {a.role} · {a.tag}
          </span>
          <span className={styles.bio}>{a.bio}</span>
          <span className={styles.name}>{a.name}</span>
        </Link>
      ))}
    </div>
  );
}
